import React from 'react';
import { TextField } from '@mui/material';

/**
 * REPORTING-CENTER.1 — shared From/To date-range filter.
 *
 * Generalizes the inline `type="date"` TextField pair used on
 * OwnershipReports.tsx (which intentionally keeps its own copy for now —
 * migrating it here is a follow-up). Values are `YYYY-MM-DD` strings as
 * produced by the native date input; empty string means unset.
 */

interface Props {
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  disabled?: boolean;
  fromLabel?: string;
  toLabel?: string;
  width?: number;
}

const DateRangeFilter: React.FC<Props> = ({
  from,
  to,
  onFromChange,
  onToChange,
  disabled,
  fromLabel = 'From',
  toLabel = 'To',
  width = 155,
}) => (
  <>
    <TextField
      label={fromLabel}
      type="date"
      size="small"
      value={from}
      onChange={e => onFromChange(e.target.value)}
      disabled={disabled}
      slotProps={{ inputLabel: { shrink: true } }}
      sx={{ width }}
    />
    <TextField
      label={toLabel}
      type="date"
      size="small"
      value={to}
      onChange={e => onToChange(e.target.value)}
      disabled={disabled}
      slotProps={{ inputLabel: { shrink: true } }}
      sx={{ width }}
    />
  </>
);

export default DateRangeFilter;
